import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useSite } from "../context/SiteContext";
import { useSeo } from "../components/site/Seo";
import { SectionHeader } from "../components/site/Cards";
import { CheckCircle2 } from "lucide-react";

export default function About() {
  const { settings } = useSite();
  useSeo({ title: `About | ${settings.brand_name || "Agni Shiksha"}`, description: "Our mission to make serious exam preparation accessible to every aspirant." });
  return (
    <div className="pb-24">
      <section className="hero-glow container-px pt-16 pb-10 max-w-3xl">
        <p className="text-xs uppercase tracking-widest text-ember mb-3">About Agni Shiksha</p>
        <h1 className="font-heading text-3xl lg:text-5xl font-extrabold tracking-tight">A student's location should not decide the quality of their practice.</h1>
      </section>
      <section className="container-px max-w-3xl">
        <div className="prose-invert text-content-secondary leading-relaxed space-y-4 text-base"
          dangerouslySetInnerHTML={{ __html: settings.about_content || "" }} />
        <div className="grid sm:grid-cols-2 gap-4 mt-10">
          {["Realistic exam practice", "Accessible test series", "PYQs & MCQs", "Mock tests", "Performance analysis", "Technology-enabled preparation"].map((t) => (
            <div key={t} className="card-surface p-4 flex items-center gap-2.5 text-sm"><CheckCircle2 className="w-4 h-4 text-emerald-400" /> {t}</div>
          ))}
        </div>
        <div className="flex flex-wrap gap-2.5 mt-12">
          {["Full-length mocks", "Previous-year questions", "Bilingual practice", "Detailed solutions", "Performance analytics"].map((t) => (
            <span key={t} className="chip">{t}</span>
          ))}
        </div>
      </section>
    </div>
  );
}
